document.addEventListener('DOMContentLoaded', function() {
    var triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            var imageUrl = this.getAttribute('data-image-url');
            var mealName = this.getAttribute('data-meal-name');
            openPopup(imageUrl, mealName);
        });
    });
});

function openPopup(imageUrl, mealName) {
    document.getElementById("popupImage").src = imageUrl;
    document.getElementById("mealName").innerText = mealName
}